const user = {
  first_name: "First name",
  last_name: "Last name",
  email: "Email address",
  gender: "Gender",
  phone_number: "Mobile number",
  birthday_with_format: "Date of birth mm/dd/yyyy",
  gender_options: {
    male: "Male",
    female: "Female",
    unspecified: "Unspecified",
  },
  culture_id: "Select your family’s country of origin",
  other_culture_name: "Please specify your family’s country of origin",
  mexico_state_id: "Which Mexico state does your family come from?",
  interests: "Interests",
  language: "Language",
  language_options: {
    spanish: "Spanish",
    english: "English",
  },
  profile: {
    cancel_edit_cta: "Cancel",
    payment_cta_title: "Payment Info",
    submit_cta: "Submit Changes",
  },
};

export default user;
